import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import moment from "moment";
import { useSnackbar } from "notistack";

function JobItem(props) {
  const job = props.job;
  const [applied, setApplied] = useState(job.hasApplied);
  const [saved, setSaved] = useState(job.hasSaved);
  const [applying, setApplying] = useState(false);
  const [saving, setSaving] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  const hasExpired = moment(job.apply_before).isBefore(moment());

  const handleJobApply = (id) => {
    setApplying(true);
    axios.post("api/seeker/apply_job", { id }).then((resp) => {
      if (resp.data.status == "success") {
        setApplied(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setApplied(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    }).finally(() => {
      setApplying(false);
    });
  };

  const handleJobSave = (e, id) => {
    e.preventDefault();
    setSaving(true);
    axios.post("api/seeker/save_job", { id }).then((resp) => {
      if (resp.data.status == "success") {
        setSaved(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setSaved(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    }).finally(() => {
      setSaving(false);
    });
  };



    const ExperienceText = () => {
    if (job.experience_type === "F") return "Freshers";
    if (job.experience_type === "E") {
      const minExp = job.min_exp ? `${job.min_exp} ${job.min_exp_unit || "years"}` : "";
      const maxExp = job.max_exp ? `${job.max_exp} ${job.exp_unit || "years"}` : "";
      if (minExp && maxExp) {
        return `${minExp} - ${maxExp}`;
      }else if (minExp) {        return `${minExp}+`;
      } else if (maxExp) {
        return `Up to ${maxExp}`;
      }
      return  "Experienced";
    }
    return "Not Specified";
  }

  const ExpiryText = () => {
    if (job.expiry_data === "Expired") {
      return <div className="text-danger"><i className="ri-timer-line"></i>Job Expired</div>;
    }
    else {      return <div><i className="ri-timer-line"></i> {job.expiry_data} remaining</div>;
    }
  }

  return (
    <div className="twm-jobs-grid-style1">
      <div className="twm-media">
        <Link to={`/jobs/${job.slug}`}>
          {job.photo ? (
            <img src={`/uploads/emp_img/${job.photo}`} alt={job.job_title} />
            // <img src={`/filemanager/${job.clientslug}_${job.clientid}/${job.photo}`} alt={job.job_title} />

          ) : (
            <img src="/default/default_company_logo.jpg" alt={job.job_title} />
          )}
        </Link>
      </div>
      <div className="company_name">

        {job.job_title != null ? (
            <Link to={`/jobs/${job.slug}`} className="twm-job-title">
              {job.job_title}
            </Link>
          ) : (
            ""
        )}

        {/* <Link to={`/company/${job.clientslug}`}>{job.comp_name}</Link> */}

          {job.job_location != null ? (
            <p className="twm-job-address text-muted">
               {job.job_location}
            </p>
          ) : (
            ""
          )}
      </div>
        {job.newspaper_id != null ? (
          <div className="twm-jobs-category">
            <span className="twm-jobs-cat-name">{job.newspaper_name}</span>
          </div>
        ) : (
          ""
        )}

      <div className="twm-mid-content">
        {/* {job.experience_type == "N" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line"></i> No Experience
          </span>
        ) : job.experience_type == "F" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line"></i> Fresher
          </span>
        ) : job.experience_type == "E" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line">&nbsp;</i>  
            {job.min_exp}
            {job.min_exp_unit === job.exp_unit 
              ?  `- ${job.max_exp}${job.exp_unit}`
              : ` ${job.min_exp_unit ? job.min_exp_unit : ""} - ${job.max_exp} ${job.exp_unit}`
            }
          </span>
        ) : (
          ""
        )} */}
         <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line"></i> <ExperienceText />
          </span>

        {job.job_type != null ? (
          <span className="twm-job-websites text-muted">
            <i className="ri-building-line"></i> {job.job_type}
          </span>
        ) : (
          ""
        )}
      <span className="twm-job-post-duration">
        <i class="ri-calendar-line"></i> {moment(job.created_at).fromNow()}
      </span>

          {job.salary_type == "R" ? (
                <span className="text-muted">
                  {job.jobcur} {job.minsalary}-{job.maxsalary}{" "}
                  <small>/ {job.salary_unit}</small>
                </span>
              ) : job.salary_type == "F" ? (
                <span className="text-muted">
                  {job.jobcur} {job.minsalary}
                  <small>/{job.salary_unit}</small>
                </span>
              ) : job.salary_type == "N" ? (
                <span className="text-muted">Negotiable</span>
              ) : (
                ""
          )}

        {job.work_type != null ? (
              <span className="job_loc">
                <i className="ri-map-pin-line"></i>
                <em className="badge">{job.work_type}</em> 
              </span>
          ) : (
          ""
        )}

      <div className="skill_tag">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles" aria-hidden="true"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path><path d="M20 2v4"></path><path d="M22 4h-4"></path><circle cx="4" cy="20" r="2"></circle></svg>
        <div className="skill_tag_list">
          {job.jobskills && job.jobskills.length > 0
            ? job.jobskills.slice(0, 4).map((skillitem, idx) => (
                <span key={idx} className="badge badge-light" title={skillitem.title}>
                  {skillitem.title.length > 50 
                    ? skillitem.title.substring(0, 50) + '...' 
                    : skillitem.title
                  }
                </span>
              ))
            : ""}
        </div>
        <div className="save-jobs-item">
          {isAuthenticated && userType === "seeker"  ? (
            saved ? (
              <Link to="/profile?tab=savedJobs" aria-label="Saved Jobs" title="Saved Jobs">
                <i className="ri ri-bookmark-fill"></i> 
              </Link>
            ) :(
            <button
              type="button"
              onClick={(e) => handleJobSave(e, job.id)}
              className="twm-jobs-browse new_btn"
              disabled={saving}>
              {saving ? <i className="ri ri-loader-4-line ri-spin"></i> : <i className="ri ri-bookmark-line"></i>}
            </button>
            ) 
          ): null}
        </div>
      </div>

      </div>
      <div className="twm-right-content">

        <div className="exp-and-view">
          <span><ExpiryText /></span>
          <span><i className="ri-eye-line"></i> {job.views}</span>
        </div>

        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <Link
              to={`/jobs/${job.slug}`}
              className="btn btn-outline-primary btn-sm">
                View Detail
            </Link>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            {!isAuthenticated && job.apply_online === "Y" && job.daysDifference >= 0 ? (
                  <Link 
                    to="/login" 
                    className="btn btn-outline-primary btn-sm twm-jobs-browse site-button"
                  >
                    <i className="ri ri-send-plane-line"></i> Apply Now
                  </Link>
                              ) : null}
            {isAuthenticated && userType === "seeker" && job.apply_online === "Y" && job.expiry_data !== "Expired" ? (
              applied ? (
            <Link
              to="/profile?tab=appliedJobs"
              className="btn btn-outline-success"
            >
             <i className="ri ri-send-plane-line"></i> Already Applied
            </Link>
                ) :(
            <button
              type="button"
              onClick={() => handleJobApply(job.id)}
              className="btn btn-outline-primary btn-sm twm-jobs-browse"
              disabled={applying}
            >
              <i className="ri ri-send-plane-line"></i> {applying ? "Applying..." : "Apply Now"}
            </button>
                )
            ) : 
            null}
            {/* <Link
              to={`/jobs/${job.slug}`}
              className="twm-jobs-browse">
              Apply Now
            </Link> */}
          </div>
        </div>

            {/* <div className="twm-jobs-amount">
              {job.salary_type == "R" ? (
                <div>
                  {job.jobcur} {job.minsalary}-{job.maxsalary}{" "}
                  <span>/ {job.salary_unit}</span>
                </div>
              ) : job.salary_type == "F" ? (
                <div>
                  {job.jobcur} {job.minsalary}
                  <span>/ {job.salary_unit}</span>
                </div>
              ) : job.salary_type == "N" ? (
                <div>Negotiable</div>
              ) : (
                ""
              )}
            </div> */}
            

        {/* {!isAuthenticated ? (
          hasExpired ? (
            <button className="btn btn-danger">Expired</button>
          ) : (
            <Link to={`/login`} className="twm-jobs-browse site-text-primary">
              Apply Now
            </Link>
          )
        ) : null}
        {isAuthenticated && userType == "seeker" ? (
          applied ? (
            <Link
              to="/profile?tab=appliedJobs"
              className="btn btn-outline-success"
            >
              Already Applied
            </Link>
          ) : hasExpired ? (
            <button className="btn btn-danger">Expired</button>
          ) : (
            <a
              href="javascript:;"
              onClick={() => handleJobApply(job.id)}
              className="site-button"
            >
              Apply Now
            </a>
          )
        ) : null} */}
      </div>
    </div>
  );
}

export default JobItem;
